import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const articles = [{
  title: 'Kieferorthopädie – von Grund auf schöne Zähne',
  excerpt: 'Wenn wir von einem schönen Lächeln reden, denken die meisten Menschen an strahlend weiße Zähne. Ebenso wichtig ist aber ein...'
}, {
  title: 'Invisalign oder feste Zahnspange im Erwachsenenalter',
  excerpt: 'Der Wunsch nach geraden Zähnen endet nicht mit der Jugend. Immer mehr Erwachsene entscheiden sich für eine kieferorthopädische Behandlung...'
}, {
  title: 'Veneers bei Bruxismus: Sind sie die richtige Wahl?',
  excerpt: 'Nächtliches Zähneknirschen hinterlässt deutliche Spuren: abgeschliffene Kauflächen, verkürzte Schneidezähne und ein ungleichmäßiges Lächeln...'
}, {
  title: 'Langfristige Folgen unbehandelter Zahnarztangst',
  excerpt: 'Ein ungutes Gefühl macht sich breit, wenn der nächste Kontrolltermin näher rückt. Die Gedanken kreisen um mögliche Schmerzen...'
}, {
  title: 'Oralchirurgie vs. Kieferchirurgie: Unterschiede',
  excerpt: 'Der Überweisungsschein zur Fachärztin oder zum Facharzt liegt vor Ihnen, doch die Bezeichnung wirft Fragen auf...'
}, {
  title: 'Wie sieht eine optimale Zahn- und Kieferstellung aus?',
  excerpt: 'Ein strahlendes Lächeln beim ersten Date, das selbstbewusste Präsentieren im Berufsleben oder das unbeschwerte Lachen...'
}];
export function BlogPreview() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-32 bg-beige" data-id="element-29">
      <div className="max-w-7xl mx-auto px-6" data-id="element-30">
        <div className="text-center mb-16" data-id="element-31">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-poppins font-bold text-schwarz mb-4 uppercase tracking-tight" data-id="element-32">
            Immer Up to Date
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-gray-medium font-lora" data-id="element-33">
            Wir verraten Ihnen die besten Pflegetipps mit unseren Blogbeiträgen
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-34">
          {articles.map((article, index) => <motion.article key={index} variants={itemVariants} whileHover={{
          y: -5
        }} className="bg-weiss p-8 border border-gray-200 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col h-full" data-id="element-35">
              <h3 className="text-xl font-poppins font-bold text-schwarz mb-4 line-clamp-2" data-id="element-36">
                {article.title}
              </h3>
              <p className="text-gray-medium font-lora text-sm mb-8 flex-grow line-clamp-3 leading-relaxed" data-id="element-37">
                {article.excerpt}
              </p>
              <Link to="/blog" className="inline-flex items-center text-navy font-poppins font-bold text-sm uppercase tracking-widest group" data-id="element-38">
                Mehr Infos
                <ArrowRightIcon className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-39" />
              </Link>
            </motion.article>)}
        </motion.div>

        <div className="text-center" data-id="element-40">
          <Link to="/blog" className="inline-block border-2 border-schwarz text-schwarz px-10 py-4 font-poppins font-bold uppercase tracking-widest hover:bg-schwarz hover:text-weiss transition-colors" data-id="element-41">
            Zum Blog
          </Link>
        </div>
      </div>
    </section>;
}